// extracted by mini-css-extract-plugin
module.exports = {"Link":"PopupLink_Link__27MFy","LinkIcon":"PopupLink_LinkIcon__1EBB5","LinkText":"PopupLink_LinkText__2Q7FS"};